@use "@design/design-tokens/typography/typography" as *;
@use "@design/components/custom-scroll/custom-scroll" as *;

.root {
  display: flex;
  align-items: center;
  justify-content: space-between;
}

.chip {
  gap: 4px;
  padding: 6px 8px 6px 12px;
  background-color: var(--surface-default);
  color: var(--icon-soft);
}

.labelContainer {
  display: flex;
  gap: 4px;
  align-items: center;
}

.label {
  color: var(--text-default);
}

.activePeriod {
  color: var(--text-primary);
}

.menuWrapper {
  width: 160px;
  max-height: 250px;
  overflow: auto;

  @include custom-scroll-minimal;
}
